export const handleFieldChange = (formData, setFormData, name, value) => {
  setFormData({ ...formData, [name]: value });
};

// export const ENDPOINT_TOKEN = process.env.REACT_APP_ENDPOINT_TOKEN;